import React from 'react'
import { ReactComponent as Arrow } from "feather-icons/dist/icons/arrow-left-circle.svg";
import { useNavigate } from "react-router-dom";
const BackButton = () => {
    const navigate = useNavigate();
  return (
   
     <button className="text-base float-right   hover:scale-110 focus:outline-none flex justify-center px-2 py-2 rounded  cursor-pointer 
       
      border-none
    text-gray-600 
    border duration-200 ease-in-out 
   transition" onClick={() => navigate(-1)}title='Back' > <Arrow/></button>
 
  )
}

export default BackButton